import { render, staticRenderFns } from "./Corrections.vue?vue&type=template&id=065099c6&scoped=true"
import script from "./Corrections.vue?vue&type=script&lang=js"
export * from "./Corrections.vue?vue&type=script&lang=js"
import style0 from "./Corrections.vue?vue&type=style&index=0&id=065099c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065099c6",
  null
  
)

export default component.exports